export const HpTextData = {
        colXlSize: { size: 5, offset: 2 },
        colLgSize: { size: 7, offset: 1 },
        colXsSize: { size: 10 },
        headerStyles: { fontSize: "2rem", fontWeight: "600" },
        header: "Kontakta oss",
        bodyText: { paragraphs: ["Kontaktuppgifter till våra kontor finner du nedan."]}
};